<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="500" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          .text-xl.font-bold.text-center Outstanding bill
        v-col(cols="1" align="right")
          v-btn(icon @click="showDialog = false" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.primary--text.pa-6
      div.text-sm.font-semibold.neutral700--text Which invoice you would like to open?
      template(v-for="invoice in invoices")
        div.pa-3.mt-3.clickable(:style="selectedInvoice.pid === invoice.pid ? activeBorder : inactiveBorder" :key="invoice.pid" @click="selectedInvoice = invoice")
          div.d-flex.align-center
            v-icon(v-if="selectedInvoice.pid === invoice.pid" size="20" color="neutral700") mdi-radiobox-marked
            v-icon(v-else size="20" color="neutral500") mdi-radiobox-blank
            div.ml-4
              div.text-md.font-medium.danger500--text {{ (invoice.total_amount - invoice.total_paid) | displayPrice }}
              div.text-sm.neutral700--text {{ invoice.record_date | humanizeDate }}, {{ invoice.record_date | displayTime2 }}
              div.text-sm.neutral700--text {{ `Invoice #${invoice.rid}` }}

    v-divider
    v-card-actions.py-3.px-4
      v-spacer
      y-button.ml-3(label="Cancel" underline size="sm" unset-min-width @click="showDialog = false")
      y-button(label="Confirm" size="sm" unset-min-width :disabled="!selectedInvoice.pid" @click="selectInvoice")

</template>

<script>

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    invoices: {
      type: Array,
      default: (() => [])
    }
  },
  data () {
    return {
      selectedInvoice: {},
      activeBorder: {
        border: '2px solid var(--v-neutral700)',
        borderRadius: '8px',
        padding: '16px'
      },
      inactiveBorder: {
        border: '2px solid var(--v-neutral400)',
        borderRadius: '8px',
        padding: '16px'
      },
    }
  },
  computed: {
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    selectInvoice () {
      this.$emit('selected', this.selectedInvoice)
      this.showDialog = false
    }
  }
}
</script>
